"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function Executor(props) {
    var data = props.hook();
    var mountedRef = react_1.useRef(false);
    if (!mountedRef.current) {
        props.onMount(data);
    }
    react_1.useLayoutEffect(function () {
        if (!mountedRef.current) {
            mountedRef.current = true;
            return;
        }
        props.onUpdate(data);
    });
    return null;
}
exports.Executor = Executor;
